import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'remixicon/fonts/remixicon.css';
import StudentPages from '../../constants/StudentPages';
import { NavPlacement } from '../../constants/StudentPages';
// import { useAppSelector } from '../../store/Hooks';
// import { UserData } from '../../store/viewmodels/UserViewModel';


function StudentNav() {
    // const userData: UserData = useAppSelector(state => state.userData)
    const [showUserDropDown, setShowUserDropDown] = React.useState(false);
    const [showMobileMenu, setShowMobileMenu] = React.useState(false);

    let pages = new StudentPages();
    const location = useLocation();
    let pageComponents = pages.getByPlacement(NavPlacement.MAIN).map(
        item => {
            let selectionClasses: string = location.pathname === item.path ? "border-teal-500 text-gray-900" : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700";
            return <Link key={item.name} to={item.path} className={selectionClasses + " inline-flex items-center px-1 pt-1 border-b-4 text-sm font-medium"}>{item.name}</Link> //Top level nav headers
        }
    );
    pageComponents = pageComponents.reverse()

    return (
        <nav className="bg-white border-b border-gray-200 flex-none" >
            <div className="max-w-screen mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex">
                        <Link key={"linkto/"} to="/" className="flex-shrink-0 flex items-center">
                            <img className="block h-8 w-auto" src="/logo_musta.png" alt="Vikke" />
                            <span className="px-4 text-lg font-bold subpixel-antialiased tracking-wider text-gray-900">VIKKE</span>
                        </Link>
                        <div className="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                            {pageComponents}
                        </div>
                    </div>
                    <div className="hidden sm:ml-6 sm:flex sm:items-center">
                        <div className="ml-3 relative">
                            <div>
                                <button onClick={() => setShowUserDropDown(!showUserDropDown)} type="button" className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" id="user-menu" aria-expanded="false" aria-haspopup="true">
                                    <i className="ri-ghost-fill text-gray-700 hover:text-teal-500 text-3xl"></i>
                                </button>
                            </div>
                            {showUserDropDown ? <UserDropDownMenu /> : <></>}
                        </div>
                    </div>
                    <div className="-mr-2 flex items-center sm:hidden">
                        <button onClick={() => setShowMobileMenu(!showMobileMenu)} type="button" className="bg-white inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" aria-controls="mobile-menu" aria-expanded="false">
                            <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                            <svg className="hidden h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
                {showMobileMenu ? <MobileMenu /> : <></>}
            </div>
        </nav>
    );
}

function MobileMenu() {

    let navItems = new StudentPages();
    const location = useLocation();
    let mainNavElements = navItems.getByPlacement(NavPlacement.MAIN).map(item => {
        let selectionClasses: string = location.pathname === item.path ? "bg-teal-50 border-teal-500 text-teal-700" : "border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800";
        return <Link key={item.name} to={item.path} className={selectionClasses + " inline-flex items-center px-1 pt-1 border-b-4 text-sm font-medium"}>{item.name}</Link>
    });
    let profileNavElements = navItems.getByPlacement(NavPlacement.PROFILE).map(item => {
        return <Link to={item.path} className="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100">{item.name}</Link>;
    })

    return (
        <div className="sm:hidden" id="mobile-menu">
            <div className="pt-2 pb-3 space-y-1">
                {mainNavElements}
            </div>
            <div className="pt-4 pb-3 border-t border-gray-200">
                <div className="flex items-center px-4">
                    <div className="flex-shrink-0">
                        <i className="ri-ghost-fill text-gray-700 hover:text-teal-500 text-3xl"></i>
                    </div>
                    <div className="ml-3">
                        <div className="text-base font-medium text-gray-800">Matti Meikäläinen</div>
                        <div className="text-sm font-medium text-gray-500">matti@meikä.fi</div>
                    </div>
                    <button className="ml-auto bg-white flex-shrink-0 p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                        </svg>
                    </button>
                </div>
                <div className="mt-3 space-y-1">
                    {profileNavElements}
                </div>
            </div>
        </div>
    );
}

function UserDropDownMenu() {

    let navItems = new StudentPages();
    let profileNavElements = navItems.pages.filter(
        item => item.navPlacements.includes(NavPlacement.PROFILE)
    ).map(
        item => <Link to={item.path} key={"dropdownitem" + item.name} className="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100">{item.name}</Link>
    )

    return (
        <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="user-menu">
            {profileNavElements}
        </div>
    );

}


export default StudentNav;
